// extracted by mini-css-extract-plugin
export var arrows = "_7e-6";
export var decrementer = "_7e-a";
export var disabled = "_7e-4";
export var error = "_7e-1";
export var hiddenText = "_7e-b";
export var incrementer = "_7e-9";
export var input = "_7e-8";
export var inputWrapper = "_7e-0";
export var leadingIcon = "_7e-c";
export var readonly = "_7e-3";
export var regular = "_7e-7";
export var small = "_7e-5";
export var warning = "_7e-2";